<div id="app" [class]="isNavCollapsed ? 'collapsed' : ''" [attr.data-whitelabel]="whitelabel">
  <app-nav-menu></app-nav-menu>
  <div id="app-wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
  <app-toasts class="toast-wrapper" aria-live="polite" aria-atomic="true"></app-toasts>
</div>

<ngx-spinner #rootSpinner [fullScreen]="true"></ngx-spinner>